export const getInputTypeCount = (data: any) => {
  const counts: any = {};

  data.forEach((item: any) => {
    const type = item.type;
    counts[type] = (counts[type] || 0) + 1;
  });

  return counts;
};
